import { DestinationSearchResultsQuery } from 'data/graphql/queries/client/destinations'
import { isServer } from 'data/helpers/ssr'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setSearchingDestinations } from 'store/searchbar'
import { useQuery } from 'urql'
import { useDebounce } from 'use-debounce'

export const useDestinationSearch = (searchParam: string) => {
  const [debouncedSearchParam] = useDebounce(searchParam, 400)
  const dispatch = useDispatch()

  const [{ data, fetching }] = useQuery({
    query: DestinationSearchResultsQuery,
    variables: {
      regionsFilter: {
        value: debouncedSearchParam,
      },
      subRegionsFilter: {
        value: debouncedSearchParam,
      },
      citiesFilter: {
        value: debouncedSearchParam,
      },
    },
    pause: !debouncedSearchParam || debouncedSearchParam === '' || isServer,
  })

  useEffect(() => {
    dispatch(setSearchingDestinations(fetching))
  }, [fetching])


  return { results: data }
}
